import { render, staticRenderFns } from "./AspectDefault.vue?vue&type=template&id=42b5d6e9&scoped=true&"
import script from "./AspectDefault.vue?vue&type=script&lang=js&"
export * from "./AspectDefault.vue?vue&type=script&lang=js&"
import style0 from "./AspectDefault.vue?vue&type=style&index=0&id=42b5d6e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b5d6e9",
  null
  
)

export default component.exports